/**
 * Single variable de entorno for the main Mux + CTA funnel (`MuxVideoPlayerWithCTA` / Telegram packs):
 * set `VITE_MUX_CTA_UNIVERSAL_PLAYBACK_ID` to one public playback ID (or paste the stream URL
 * from Mux). Used when country-specific IDs are unset so you can ship “one video for everyone”
 * first, then split ES/EN/per-country later.
 */

function parseMuxPlaybackIdFromEnvValue(
  raw: string | undefined,
): string | undefined {
  if (!raw || typeof raw !== "string") return undefined;
  let t = raw.trim();
  if (!t) return undefined;

  const muxUrlMatch = t.match(/stream\.mux\.com\/([^/.?]+)/);
  if (muxUrlMatch) {
    t = muxUrlMatch[1];
  }

  if (t.length < 10 || /your-|tu-|example|xxx/i.test(t)) return undefined;
  return t;
}

/** Public Mux playback for the default funnel; undefined if unset or invalid. */
export function getMuxCtaUniversalPlaybackId(): string | undefined {
  return parseMuxPlaybackIdFromEnvValue(
    import.meta.env.VITE_MUX_CTA_UNIVERSAL_PLAYBACK_ID as string | undefined,
  );
}
